import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { DASHBOARD_COLORS } from '../dashboardStyles';

const SalesOverviewPeriodToggle = ({ value, onChange, compact = false, disabled = false }) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    value={value}
    disabled={disabled}
    onChange={(_, next) => {
      if (next) onChange(next);
    }}
    sx={{
      bgcolor: DASHBOARD_COLORS.surface,
      border: `1px solid ${DASHBOARD_COLORS.border}`,
      borderRadius: 1.5,
      '& .MuiToggleButton-root': {
        textTransform: 'none',
        fontWeight: 600,
        fontSize: compact ? '0.65rem' : '0.75rem',
        px: compact ? 1 : 1.5,
        py: compact ? 0.25 : 0.5,
        border: 'none',
        color: DASHBOARD_COLORS.textMuted,
        '&.Mui-selected': {
          bgcolor: '#eff6ff',
          color: '#2563eb',
        },
      },
    }}
  >
    <ToggleButton value="monthly">Monthly</ToggleButton>
    <ToggleButton value="weekly">Weekly</ToggleButton>
  </ToggleButtonGroup>
);

export default SalesOverviewPeriodToggle;
